import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';
import { CreatePaymentLinkDto } from '../models/payment-link/create-payment-link.dto';
import { UpdatePaymentLinkDto } from '../models/payment-link/update-payment-link.dto';

@Injectable({
  providedIn: 'root'
})
export class PaymentLinkService extends ApiService {
  createPaymentLink(dto: CreatePaymentLinkDto, idempotencyKey?: string) {
    const options: any = { body: dto };
    if (idempotencyKey) {
      options.headers = { 'idempotency-key': idempotencyKey };
    }
    return this.post(API.createPaymentLink, options);
  }

  getPaymentLinks(
    accountNumber: string,
    filter?: {
      isFavorite?: boolean;
      name?: string;
      status?: string;
      page?: number;
      limit?: number;
    }
  ) {
    return this.post(`${API.getPaymentLinks}/list/${accountNumber}`, { body: filter || {} });
  }

  getPaymentLinkByToken(token: string) {
    return this.get(`${API.getPaymentLinkByToken}/${token}`);
  }

  updatePaymentLink(id: string, dto: UpdatePaymentLinkDto) {
    return this.put(`${API.updatePaymentLink}/${id}`, { body: dto });
  }
  markPaymentLinkAsRejected(token: string, rejectedReason?: string) {
    return this.post(`${API.getPaymentLinks}/${token}/reject`, { body: { rejectedReason } });
  }

  removePaymentLink(id: string) {
    return this.delete(`${API.removePaymentLink}/${id}`);
  }
}
